import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("admin_token") || "");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      axios
        .get(`${API}/admin/me`, { headers: { authorization: `Bearer ${token}` } })
        .then((res) => {
          setAdmin(res.data);
          setLoading(false);
        })
        .catch(() => {
          setToken("");
          localStorage.removeItem("admin_token");
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (username, password) => {
    const res = await axios.post(`${API}/admin/login`, { username, password });
    setToken(res.data.token);
    setAdmin({ username: res.data.username, role: "admin" });
    localStorage.setItem("admin_token", res.data.token);
    return res.data;
  };

  const logout = () => {
    setToken("");
    setAdmin(null);
    localStorage.removeItem("admin_token");
  };

  const authHeaders = { authorization: `Bearer ${token}` };

  return (
    <AuthContext.Provider value={{ admin, token, loading, login, logout, authHeaders }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
